<template>
  <div class="youtaofang">
       <topTitle title="五有服务" :list="list" :newData="newData"></topTitle>
       <p class="top_p">钱湖柏庭园区规划、设计均委托绿城集团潜心打造，将美国养老社区的产品标准本土化，以360度无死角适老化设计确保园区硬件品质。周到的适老化设计是园区精细化设计的一部分，“新关爱主义”的内在精神倡导设计师们真正从生理、心理上调研、理解老年人的需求，一切设计均做到细致全面。</p>
        <div class="item_bd">
            <img :src="item.img" alt="" v-for="(item,key) in list2" :key='key'>
        </div>
  </div>
</template>
  <script>
  import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
          {
              title: "【五有】有套房",
              small_title: "HAVE A SUITE",
              hasTitle: "有套房",
          },
          {
              title: "【五有】有块地",
              hasTitle: "有块地",
          },
          {
              title: "【五有】有地暖",
              hasTitle: "有地暖",
          },
          {
              title: "【五有】有社团",
              small_title: "HAVE A CLUB",
              hasTitle: "有社团",
          },
          {
              title: "【五有】有管家",
              small_title: "HAVE A BUTLER",
              hasTitle: "有管家",
          }
      ],
      newData: 0,
        list2:[{
            img:require('../../assets/image/fuwu/fang_1.png')
        },
        {
            img:require('../../assets/image/fuwu/fang_2.png')
        },
        {
            img:require('../../assets/image/fuwu/fang_3.png')
        }]
    };
  },
  methods: {},
  mounted: function() {},
  components: {
      topTitle
  },
   props: {
  
  },
};
</script>
<style scoped="scoped">
.youtaofang{
    width: 100%;
    height: 100%;

}
.top_p {
margin-top: 0.6625rem;
 text-align: left;
font-size: 0.35rem;
font-family: PingFang SC;
font-weight: 400;
color: #222222;
line-height: 0.675rem;
text-indent: 2em;
}
.item_bd{
    margin-top: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item_bd img{
    width: 4.0125rem;
/* height: 3.0125rem; */
border-radius: 0.125rem;

}
</style>